import BookIcon from '@mui/icons-material/Book';

export default BookIcon;
